import React from 'react';
import { Box } from '@mui/material';
import KpiMetric from './KpiMetric';
import { useThemeTokens } from '../../../hooks/useThemeTokens';

interface Props {
  activeProjects: number;
  completedProjects: number;
  totalProducts: number;
  totalVideos: number;
  totalOrders: number;
}

// The KPI values run a five-step gold ramp. The light ramp DARKENS left to
// right, which works on a white card but inverts into near-invisibility on the
// dark canvas (#2E1F0A on #18212F is effectively black on black). The dark ramp
// therefore LIGHTENS instead, keeping the same gold identity and step count
// while every value stays legible. Light values are unchanged.
const RAMP_LIGHT = ['#AB854A', '#8A6D41', '#6C583A', '#44331A', '#2E1F0A'];
const RAMP_DARK = ['#D9BD8C', '#CBAB79', '#B79C73', '#A98F6B', '#9B8362'];

const DashboardKpis: React.FC<Props> = ({ activeProjects, completedProjects, totalProducts, totalVideos, totalOrders }) => {
  const { mode } = useThemeTokens();
  const ramp = mode === 'dark' ? RAMP_DARK : RAMP_LIGHT;
  return (
    <Box
      className='mt-8 w-full'
      sx={{
        borderRadius: { xs: '12px', md: '16px' },
        border: '1px solid var(--Base-100, #DFDEDE)',
        background: 'var(--surface)',
        padding: { xs: '12px 16px', md: '42px 24px' },
        boxShadow: 'var(--sh-1)'
      }}
    >
      <Box
        className='grid items-center w-full max-md:hidden'
        style={{ gridTemplateColumns: '1fr 1px 1fr 1px 1fr 1px 1fr 1px 1fr', columnGap: '16px' }}
      >
        <KpiMetric value={totalOrders} label="Total Orders" color={ramp[0]} />
        <div className='h-12 bg-border-token' />
        <KpiMetric value={activeProjects} label="Active Projects" color={ramp[1]} />
        <div className='h-12 bg-border-token' />
        <KpiMetric value={completedProjects} label="Final Delivered Projects" color={ramp[2]} />
        <div className='h-12 bg-border-token' />
        <KpiMetric value={totalProducts} label="Total Products" color={ramp[3]} />
        <div className='h-12 bg-border-token' />
        <KpiMetric value={totalVideos} label="Total Videos" color={ramp[4]} />
      </Box>

      <Box className='hidden max-md:grid grid-cols-2 gap-y-4 gap-x-2 items-center w-full'>
        <KpiMetric value={totalOrders} label="Total Orders" color={ramp[0]} />
        <KpiMetric value={activeProjects} label="Active Projects" color={ramp[1]} />
        <KpiMetric value={completedProjects} label="Final Delivered Projects" color={ramp[2]} />
        <KpiMetric value={totalProducts} label="Total Products" color={ramp[3]} />
        <Box className='col-span-2 flex justify-center'>
          <KpiMetric value={totalVideos} label="Total Videos" color={ramp[4]} />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardKpis;


